import { useState, useEffect } from "react";
import SectionHeader from "../../include/SectionHeader";
import Search from "../../include/Search";
import api from "../../../services/api";

const Videos = () => {
  const [search, setSearch] = useState("");
  const [videos, setVideos] = useState([]);
  const [filteredVideos, setFilteredVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH YT VIDEOS ---------------- */
  useEffect(() => {
    setLoading(true);

    api.get("/api/pages/home/yt")
      .then(res => {
        const ytVideos = res.data?.yt_videos || [];
        setVideos(ytVideos);
        setFilteredVideos(ytVideos);
      })
      .catch(err => {
        console.error("YT video fetch error", err);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 300);
      });
  }, []);

  /* ---------------- SEARCH FILTER ---------------- */
  useEffect(() => {
    const result = videos.filter(v =>
      v.name.toLowerCase().includes(search.toLowerCase()) ||
      v.title.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredVideos(result);
  }, [search, videos]);

  return (
    <>
      <div className="yt_videos_list_section">

        <section className="videos-list-container">
          <div className="container">
            <SectionHeader title="Healing Begins with Knowledge" />
            <Search onSearch={value => setSearch(value)} />

            {!loading && filteredVideos.length === 0 && (
              <p className="no-results">No videos found.</p>
            )}

            <div className="row">
              {loading
                ? [1, 2, 3].map((_, index) => (
                    <div className="col-lg-4 col-md-6 mb-4" key={index}>
                      <div className="video-card skeleton">
                        <div className="skeleton-video shimmer"></div>
                        <div className="mt-3">
                          <div className="skeleton-line long shimmer"></div>
                          <div className="skeleton-line medium shimmer"></div>
                        </div>
                      </div>
                    </div>
                  ))
                : filteredVideos.map((video, index) => (
                    <div className="col-lg-4 col-md-6 mb-4" key={index}>
                      <div className="video-card">
                        <iframe
                          src={video.src}
                          title={video.name}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          ></iframe>
                        <h3>{video.name}</h3>
                        <p>{video.title}</p>
                      </div>
                    </div>
                  ))}
            </div>

          </div>
        </section>
      </div>
    </>
  );
};

export default Videos;
